module.exports = __webpack_public_path__ + "img/gobelins.6980f2ae.png";